/**
 * STICKY MENU
 */
(function () {
  $(window).ready(sticky)
  $(window).on('scroll', sticky)

  let headerInner = null

  function sticky() {
    if (!headerInner) {
      headerInner = $('.header-inner')
    }

    if (window.pageYOffset > 100) {
      headerInner.addClass('sticky')
    } else {
      headerInner.removeClass('sticky')
    }
  }
})();

/**
 * CTA PARALLAX
 */
(function () {
  $(window).ready(parallax)
  $(window).on('scroll', parallax)

  let parallaxWrapper = null

  function parallax() {
    if (!parallaxWrapper) {
      parallaxWrapper = $('.parallax-wrapper')
    }

    if (parallaxWrapper.length > 0) {
      if (window.pageYOffset + window.innerHeight > parallaxWrapper.offset().top) {
        parallaxWrapper.css('background-position-y', ((parallaxWrapper.offset().top - window.pageYOffset) / 9) + '%')
      }
    }
  }
})();

/**
 * VIDEO PARALLAX
 */
(function () {
  $(window).ready(videoParallax)
  $(window).on('scroll', videoParallax)

  function videoParallax() {
    if ($(window).width() > 769) {
      let e = document.getElementById("parallax-backstretch")
      if (typeof e !== 'undefined' && e != null) {
        e.style.top = -(window.pageYOffset / 4) + "px"
      }
    }
  }
})();

/**
 * SMOOTH SCROLLING
 */
(function () {
  // Smooth scrolling with header height
  function anchorScroll(offset, speed) {
    if ($(window).width() > 980) {
      offset -= 75
    }
    $('html,body').animate({
      scrollTop: offset,
    }, speed)
    return false
  }

  $(function () {
    $('a[href^="#"]').click(function () {
      if (!this.hasAttribute('data-parent')) {
        anchorScroll($(this.hash).offset().top, 800)
      }
    })
    $(window).on('scroll.anchors', function () {
      if (window.location.hash) {
        let offset = $(window.location.hash).offset().top
        anchorScroll(offset, 0)
        $(window).off('scroll.anchors')
      }
    })
  })
})();



// WEBPACK FOOTER //
// ./resources/assets/js/script.js